import { BulkLimitConfigFileReducer, BulkLimitConfigFileReducerStateWithListObject, BulkLimitConfigFileReducerStateWithoutListObject, bulkLimitConfigFileType } from "./types";

const OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE = {
    data: {},
    loading: false,
    error: null
};
const OBJECT_WITH_LIST_RESPONSE_INIT_STATE = {
    data: {
        metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
                self: null,
                first: null,
                previous: null,
                next: null,
                last: null
            }
        },
        records: []
    },
    loading: false,
    error: null
};
const UploadBulkLimitConfigFileReducer = (state: BulkLimitConfigFileReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkLimitConfigFileReducer) => {
    switch (action.type) {
        case bulkLimitConfigFileType.UPLOAD_BULK_LIMIT_CONFIG_FILE: {
            return {
                loading: true,
            };
        }
        case bulkLimitConfigFileType.UPLOAD_BULK_LIMIT_CONFIG_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkLimitConfigFileType.UPLOAD_BULK_LIMIT_CONFIG_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
        }
        case bulkLimitConfigFileType.RESET_UPLOAD_BULK_LIMIT_CONFIG_FILE: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};
const ListBulkLimitConfigFileReducer = (state: BulkLimitConfigFileReducerStateWithListObject = OBJECT_WITH_LIST_RESPONSE_INIT_STATE, action: BulkLimitConfigFileReducer) => {
    switch (action.type) {
        case bulkLimitConfigFileType.FETCH_BULK_LIMIT_CONFIG_FILE: {
            return {
                ...state,
                loading: true
            };
        }
        case bulkLimitConfigFileType.FETCH_BULK_LIMIT_CONFIG_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data
            };
        }
        case bulkLimitConfigFileType.FETCH_BULK_LIMIT_CONFIG_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error
            };
        }
        case bulkLimitConfigFileType.RESET_FETCH_BULK_LIMIT_CONFIG_FILE:
            return {
                ...state,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                },
                loading: false,
                error: false
            };
        default:
            return { ...state };
    }
};
const DownloadBulkLimitConfigFileReducer = (state: BulkLimitConfigFileReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkLimitConfigFileReducer) => {
    switch (action.type) {
        case bulkLimitConfigFileType.BULK_LIMIT_CONFIG_FILE_DOWNLOAD: {
            return {
                loading: true,
            };
        }
        case bulkLimitConfigFileType.BULK_LIMIT_CONFIG_FILE_DOWNLOAD_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkLimitConfigFileType.BULK_LIMIT_CONFIG_FILE_DOWNLOAD_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkLimitConfigFileType.RESET_BULK_LIMIT_CONFIG_FILE_DOWNLOAD: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};
const BulkLimitConfigFileDetailReducer = (state: BulkLimitConfigFileReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkLimitConfigFileReducer) => {
    switch (action.type) {
        case bulkLimitConfigFileType.FETCH_BULK_LIMIT_CONFIG_FILE_DETAIL: {
            return {
                loading: true,
            };
        }
        case bulkLimitConfigFileType.FETCH_BULK_LIMIT_CONFIG_FILE_DETAIL_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkLimitConfigFileType.FETCH_BULK_LIMIT_CONFIG_FILE_DETAIL_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkLimitConfigFileType.RESET_FETCH_BULK_LIMIT_CONFIG_FILE_DETAIL: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};
const BulkLimitConfigFileVersionReducer = (state: BulkLimitConfigFileReducerStateWithListObject = OBJECT_WITH_LIST_RESPONSE_INIT_STATE, action: BulkLimitConfigFileReducer) => {
    switch (action.type) {
        case bulkLimitConfigFileType.BULK_LIMIT_CONFIG_FILE_VERSION: {
            return {
                loading: true,
            };
        }
        case bulkLimitConfigFileType.BULK_LIMIT_CONFIG_FILE_VERSION_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkLimitConfigFileType.BULK_LIMIT_CONFIG_FILE_VERSION_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                }
            };
        }
        case bulkLimitConfigFileType.RESET_BULK_LIMIT_CONFIG_FILE_VERSION: {
            return {
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                },
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};
const PublishBulkLimitConfigFileReducer = (state: BulkLimitConfigFileReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkLimitConfigFileReducer) => {
    switch (action.type) {
        case bulkLimitConfigFileType.PUBLISH_BULK_LIMIT_CONFIG_FILE: {
            return {
                loading: true,
            };
        }
        case bulkLimitConfigFileType.PUBLISH_BULK_LIMIT_CONFIG_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkLimitConfigFileType.PUBLISH_BULK_LIMIT_CONFIG_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkLimitConfigFileType.RESET_PUBLISH_BULK_LIMIT_CONFIG_FILE: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};
const ApproveBulkLimitConfigFileReducer = (state: BulkLimitConfigFileReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkLimitConfigFileReducer) => {
    switch (action.type) {
        case bulkLimitConfigFileType.APPROVE_BULK_LIMIT_CONFIG_FILE: {
            return {
                loading: true,
            };
        }
        case bulkLimitConfigFileType.APPROVE_BULK_LIMIT_CONFIG_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkLimitConfigFileType.APPROVE_BULK_LIMIT_CONFIG_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkLimitConfigFileType.RESET_APPROVE_BULK_LIMIT_CONFIG_FILE: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

const RejectBulkLimitConfigFileReducer = (state: BulkLimitConfigFileReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkLimitConfigFileReducer) => {
    switch (action.type) {
        case bulkLimitConfigFileType.REJECT_BULK_LIMIT_CONFIG_FILE: {
            return {
                loading: true,
            };
        }
        case bulkLimitConfigFileType.REJECT_BULK_LIMIT_CONFIG_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkLimitConfigFileType.REJECT_BULK_LIMIT_CONFIG_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkLimitConfigFileType.RESET_REJECT_BULK_LIMIT_CONFIG_FILE: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};
const ListBulkFileSpecificLimitConfigReducer = (state: BulkLimitConfigFileReducerStateWithListObject = OBJECT_WITH_LIST_RESPONSE_INIT_STATE, action: BulkLimitConfigFileReducer) => {
    switch (action.type) {
        case bulkLimitConfigFileType.FETCH_BULK_FILE_SPECIFIC_LIMIT_CONFIG: {
            return {
                ...state,
                loading: true,
            };
        }
        case bulkLimitConfigFileType.FETCH_BULK_FILE_SPECIFIC_LIMIT_CONFIG_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkLimitConfigFileType.FETCH_BULK_FILE_SPECIFIC_LIMIT_CONFIG_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                }
            };
        }
        case bulkLimitConfigFileType.RESET_FETCH_BULK_FILE_SPECIFIC_LIMIT_CONFIG: {
            return {
                ...state,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                },
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

const DeleteBulkLimitConfigFileReducer = (state: BulkLimitConfigFileReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkLimitConfigFileReducer) => {
    switch (action.type) {
        case bulkLimitConfigFileType.DELETE_BULK_LIMIT_CONFIG_FILE: {
            return {
                loading: true,
            };
        }
        case bulkLimitConfigFileType.DELETE_BULK_LIMIT_CONFIG_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkLimitConfigFileType.DELETE_BULK_LIMIT_CONFIG_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkLimitConfigFileType.RESET_DELETE_BULK_LIMIT_CONFIG_FILE: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

export {
    UploadBulkLimitConfigFileReducer,
    ListBulkLimitConfigFileReducer,
    DownloadBulkLimitConfigFileReducer,
    BulkLimitConfigFileDetailReducer,
    BulkLimitConfigFileVersionReducer,
    PublishBulkLimitConfigFileReducer,
    ApproveBulkLimitConfigFileReducer,
    RejectBulkLimitConfigFileReducer,
    ListBulkFileSpecificLimitConfigReducer,
    DeleteBulkLimitConfigFileReducer
}